const PREFIX = "ab-form";
const CLASS_FORM_FEEDBACK = `${PREFIX}__feedback`;

const AB_FORM_NAMES = {
  CLASS_FORM: PREFIX,
  CLASS_FORM_SUBMITTED: `${PREFIX}--submitted`,
  CLASS_FORM_CONTROL: `${PREFIX}__control`,
  CLASS_FORM_LABEL: `${PREFIX}__label`,
  CLASS_FORM_INPUT: `${PREFIX}__input`,
  CLASS_FORM_ERROR_MESSAGE: `${PREFIX}__error`,
  CLASS_FORM_FEEDBACK,
  CLASS_FORM_FEEDBACK__SUCCESS: `${CLASS_FORM_FEEDBACK}--success`,
  CLASS_FORM_FEEDBACK__ERROR: `${CLASS_FORM_FEEDBACK}--error`,
  CLASS_FORM_SUBMIT: `${PREFIX}__submit`,
  CLASS_INVALID: `${PREFIX}__control--invalid`,
};

export default AB_FORM_NAMES;